import { HeaderIcon, NaviIconSearch } from '@banhala/ui-kit';
import { useNavigator } from '../../utils';
import { useLogAnalyticsEvent } from '../../hooks/useLogAnalyticsEvent';

type Props = {
  backgroundColor?: 'white' | 'transparent';
};

export const SearchIcon = ({ backgroundColor }: Props) => {
  const { navigator } = useNavigator();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handlePress = () => {
    logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_SEARCH',
    });
    navigator.moveToSearch();
  };

  return (
    <HeaderIcon onPress={handlePress} backgroundColor={backgroundColor}>
      <NaviIconSearch />
    </HeaderIcon>
  );
};
